<ng-container *ngIf="step === 0">
  <h3>{{ payload.fields[0].title }}</h3>

  <form [formGroup]="uploadFormGroup">
    <div class="flex">
      <!-- Upload area -->

      <div class="drop-zone">
        <div class="flex" *ngIf="!uploadFormGroup.value.formFile">
          <div class="drop-zone-info">
            <rx-icon name="icon-upload-device"></rx-icon>
            <div>
              Drag your form file here or
              <a href="">upload</a>
              it from your device
            </div>
            <div class="grayout">
              Please upload high quality
              <strong>PDF</strong>
              form.
            </div>
          </div>
          <input
            type="file"
            (change)="selectFile($event)"
            name="file1"
            id="file1"
            class="inputfile"
            accept="application/pdf"
          />
          <input type="hidden" formControlName="formFileName" />
        </div>
        <div class="flex" *ngIf="uploadFormGroup.value.formFile">
          <div class="drop-zone-info">File selected, click 'Next' button to continue</div>
        </div>
        <div class="flex" *ngIf="isBusy">
          <rx-icon name="icon-spinner"></rx-icon>
          &nbsp; Please Wait...
        </div>
      </div>

      <div class="flex flex-row jcfe">
        <rx-button class="white mr10" mat-button matStepperNext (click)="onCancelClicked()">Cancel</rx-button>
        <rx-button class="blue" [disabled]="!uploadFormGroup.value.formFile" (clicked)="onNextStep()"> Next </rx-button>
      </div>
    </div>
  </form>
</ng-container>

<ng-container *ngIf="step === 1">
  <h3>{{ payload.fields[1].title }}</h3>

  <form [formGroup]="settingFormGroup">
    <div class="flex">
      <div class="flex">
        <div class="row-actions mb10">
          <div class="fs10 mb10">Form Title</div>
          <rx-input
            rxFormControlError
            formControlName="title"
            placeholder="Form Title"
            [keepPlaceholder]="true"
          ></rx-input>
        </div>

        <div class="row-actions mb10">
          <div class="fs10 mb10">Published Date</div>
          <rx-datepicker
            rxFormControlError
            [isEuDatetimeFormat]="userDateFormat$ | async"
            [placeholder]="datetimeFormat"
            [format]="datetimeFormat"
            formControlName="date"
          ></rx-datepicker>
        </div>

        <div class="row-actions mb10">
          <div class="fs10 mb10">Status</div>
          <rx-select class="form-select" placeholder="Status" [items]="payload.statuses" formControlName="status">
            <ng-template rxSelectOption let-item="item">
              <div class="fs14">{{ item.text }}</div>
            </ng-template>
          </rx-select>
        </div>
      </div>

      <div class="flex flex-row jcfe">
        <rx-button class="white mr10" mat-button matStepperNext (click)="onCancelClicked()">Cancel</rx-button>
        <rx-button class="blue" [disabled]="!uploadFormGroup.value.formFile" (clicked)="onCreateClicked()">
          Save
        </rx-button>
      </div>
    </div>
  </form>
</ng-container>
